import { documentsService } from 'hq/services';
import { useMutation } from 'react-query';
import { DocumentLanguage } from 'hq/services/documents-service.types';

export const useUpdateDocumentLanguage = () => {
  const mutationFn = async (data: { documentId: string; language: DocumentLanguage }) => {
    return await documentsService.editDocumentLanguage(data.documentId, data.language);
  };

  return useMutation(mutationFn);
};
